import { createApi } from "@reduxjs/toolkit/query/react";
import { HelpFaq } from "../types/Help";
import { ListingResponse } from "../types/Listing";
import { appBaseQuery, baseQueryWithAuthHandling } from "../utils/utils";
import { API_METHODS } from "./constants";
import { API_ENDPOINTS } from "./endpoints";
import { HelpArticleByRouteResponse, HelpArticleBySectionResponse, HelpArticleReponse, SearchHelpArticleResponse } from "../../pages/help/type";

export enum HelpApiTags {}

export const HelpAPIs = createApi({
  reducerPath: "helpApi",
  tagTypes: [],
  baseQuery: (args, api, extraOptions) =>
    baseQueryWithAuthHandling(
      appBaseQuery.withAuthJson,
      args,
      api,
      extraOptions
    ),
  endpoints: (builder) => ({

    // get faq by category
    getFaqByCategory: builder.query<ListingResponse<HelpFaq[]>, string>({
      query: (category_name: string) => {
        return {
          url: API_ENDPOINTS.HELP.FAQ_BY_CATEGORY(category_name),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        return baseQueryReturnValue;
      },
      transformResponse: (response: ListingResponse<HelpFaq[]>) => {
        return response;
      },
    }),

    // get all Help Articles for main help page
    fetchAllArticlesApi: builder.query<ListingResponse<HelpArticleReponse[]>,{ page: number; page_size: number }>(
      {
        query: ({ page, page_size })=>{
           return {
            url: API_ENDPOINTS.HELP.ALL_ARTICLES(page,page_size),
            method: API_METHODS.GET,
          };
        },
        transformErrorResponse(baseQueryReturnValue) {
          return baseQueryReturnValue;
        },
        transformResponse: (response: ListingResponse<HelpArticleReponse[]>) => {
          return response;
        },
      }
    ),

    //get Help article for section help page
      fetchArticleBySlugApi: builder.query<HelpArticleBySectionResponse,string>(
      {
        query: (slug:string)=>{
           return {
            url: API_ENDPOINTS.HELP.ARTICLE_BY_SLUG(slug),
            method: API_METHODS.GET,
          };
        },
        transformErrorResponse(baseQueryReturnValue) {
          return baseQueryReturnValue;
        },
        transformResponse: (response: HelpArticleBySectionResponse) => {
          return response;
        },
      }
    ),
    // get Help article for pop-up
      fetchArticleByRouteApi: builder.query<HelpArticleByRouteResponse,string>(
      {
        query: (route:string)=>{
           return {
            url: API_ENDPOINTS.HELP.ARTICLE_BY_ROUTE(route),
            method: API_METHODS.GET,
          };
        },
        transformErrorResponse(baseQueryReturnValue) {
          return baseQueryReturnValue;
        },
        transformResponse: (response: HelpArticleByRouteResponse) => {
          return response;
        },
      }
    ),

    // get Help main search results
    fetchSearchResultsApi : builder.query<SearchHelpArticleResponse[],string>(
      {
        query: (query:string)=>{
           return {
            url: API_ENDPOINTS.HELP.ARTICLE_SEARCH(query),
            method: API_METHODS.GET,
          };
        },
        transformErrorResponse(baseQueryReturnValue) {
          return baseQueryReturnValue;
        },
        transformResponse: (response: SearchHelpArticleResponse[]) => {
          return response;
        },
      }
    ),
  }),
});

export const {
  useGetFaqByCategoryQuery,
  useFetchAllArticlesApiQuery,
  useFetchArticleBySlugApiQuery,
  useFetchArticleByRouteApiQuery,
  useFetchSearchResultsApiQuery
} = HelpAPIs;
